<template>
    <div class="max-w-xl mx-auto">
        <div
            class="py-8 px-4 mt-2 sm:mt-24 sm:pt-8 sm:px-16 sm:border border-gray-100 border-dotted"
        >
            <div class="font-bold text-xl text-center mb-2 sm:mb-8">
                {{ $t('forget.reset.password') }}
            </div>

            <div class="text-center mb-2 sm:mb-8">
                {{ $t('forget.greet') }}
            </div>
            <div v-if="saveStatus !== 'emailSent'">
                <formFieldRow
                    name="email"
                    :label="$t('login.email')"
                    labelWidthClass="sm:w-24"
                    :errors="errors"
                >
                    <template #default="{hasError}">
                        <input
                            class="form-input"
                            type="email"
                            :class="{ 'border-red': hasError }"
                            v-model.trim="email"
                        />
                    </template>
                </formFieldRow>
            </div>
            <div
                v-if="saveStatus === 'emailSent'"
                class="p-4 sm:p-8 text-xl text-blue"
            >
                {{ $t('forget.email.sent') }}
            </div>
            <div v-if="saveStatus !== 'emailSent'">
                <errorBox :message="errors.server" />
                <div class="flex text-lg">
                    <div class="hidden sm:block sm:w-24"></div>
                    <loadingButton
                        class="text-white bg-primary border-primary flex-grow justify-center"
                        :status="saveStatus"
                        @click="resetPassword"
                    >
                        {{ $t('forget.send.email') }}
                    </loadingButton>
                </div>
            </div>
            <div class="flex flex-col">
                <router-link class="mt-4 text-sm ml-auto underline" to="/login">
                    {{ $t('common.back') }}
                </router-link>
            </div>
            <div class="remind-message-container mt-2">
                請把我們的系統電郵地址
                <a href="mailto:cs@tryhala.com">cs@tryhala.com</a>
                加入為聯絡人，以免您的電郵系統把回覆誤當為垃圾郵件
            </div>
        </div>
    </div>
</template>

<script>
import errorBox from '@/components/errorBox.vue';
import formFieldRow from '@/components/formFieldRow.vue';
import loadingButton from '@/components/loadingButton.vue';
import { instance } from '@/utils/ajax';
import { validate } from '@/utils/validationUtil';
import img6s112 from '@/assets/img/6-112.png';
import img4s112 from '@/assets/img/4-112.png';

const resetPassword = async function(data) {
    try {
        let result = await instance.post('/api/pwd/requestReset', data);
        return result.data;
    } catch (e) {
        return { success: false, errors: { error: 'error.server' } };
    }
};

export default {
    components: {
        errorBox,
        formFieldRow,
        loadingButton
    },
    data() {
        return {
            email: undefined,
            errors: {},
            saveStatus: undefined,
            userName: undefined
        };
    },
    created() {
        this.bubbleImg = img6s112;
    },
    computed: {
        greetText() {
            if (this.saveStatus === 'emailSent') {
                return this.$t('forget.greet.user', this.userName);
            } else {
                return this.$t('forget.greet');
            }
        }
    },
    methods: {
        async resetPassword() {
            const data = { email: this.email };
            this.errors = {};
            const v = validate(this.errors, data, {
                email: { required: true }
            });
            if (v.hasError) {
                this.errors = v.errors;
                return;
            }
            this.saveStatus = 'loading';
            const result = await resetPassword(data);
            if (result.success) {
                this.saveStatus = 'emailSent';
                this.userName = result.data.userName;
                this.bubbleImg = img4s112;
            } else {
                this.saveStatus = undefined;
                this.errors = result.data.errors;
            }
        }
    }
};
</script>
